import { Component, HostListener, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SsoAuthService } from '../../sso/Services/sso-auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile-header',
  imports: [],
  templateUrl: './user-profile-header.component.html',
  styleUrl: './user-profile-header.component.scss'
})
export class UserProfileHeaderComponent implements OnInit {
  userDetails: any;
  fullName: string = '';
  showThemes = false;
  showApps = false;
  @Input() admin: boolean = false
  orgUrl = environment.orgUrl;
  constructor(
    private ssoAuthService: SsoAuthService,
  ) { }

  ngOnInit(): void {
    this.loadUserDetails();
  }

  private loadUserDetails() {
    const accessToken = localStorage.getItem('AccessToken');
    try {
      if (accessToken) {
        const payloadPart = accessToken.split('.')[1];
        const decodedPayload = JSON.parse(window.atob(payloadPart));
        const { firstName, middleName, lastName } = decodedPayload;
        this.fullName = [firstName, middleName, lastName]
          .filter(Boolean)
          .join(' ');
      } else {
        this.userDetails = JSON.parse(localStorage.getItem('UserDetails')!);
        this.fullName = this.userDetails?.userName || '';

      }
      console.log(this.userDetails, '--uesr details')
    } catch (err) {
      console.error('Token decoding failed, using fallback:', err);
      this.userDetails = JSON.parse(localStorage.getItem('UserDetails')!);
      this.fullName = this.userDetails?.userName || '';
    }
  }

  onThemeClick(event: Event) {
    event.stopPropagation();
    this.showThemes = !this.showThemes;
    if (this.showThemes) this.showApps = false;
  }

  logout(event: Event) {
    this.ssoAuthService.logOut();
    event.stopPropagation();
  }

  toggleShowApps(event: any) {
    event.stopPropagation();
    this.showThemes = false;
    this.showApps = !this.showApps;
  }

  clickApps(url: string) {
    window.location.href = url;
  }

  onViewProfile(): void {
    window.open(`${environment.SSO_URL}/dashboard`, '_blank');
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.acco-header')) {
      this.showThemes = false;
      this.showApps = false;
    }
  }
}
